import React from 'react';
import { Navbar } from '../components/Navbar';
import { HeroSection } from '../components/HeroSection';
import { ValuePropsSection } from '../components/ValuePropsSection';
import { ServicesSection } from '../components/ServicesSection';
import { WhyChooseUsSection } from '../components/WhyChooseUsSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { PricingSection } from '../components/PricingSection';
import { ServiceAreaSection } from '../components/ServiceAreaSection';
import { CTABannerSection } from '../components/CTABannerSection';
import { Footer } from '../components/Footer';
export function HomePage() {
  return <div className="w-full min-h-screen" style={{
    fontFamily: 'Inter, sans-serif'
  }} data-id="element-286">
      <Navbar data-id="element-287" />
      <main data-id="element-288">
        <HeroSection data-id="element-289" />
        <ValuePropsSection data-id="element-290" />
        <ServicesSection data-id="element-291" />
        <WhyChooseUsSection data-id="element-292" />
        <TestimonialsSection data-id="element-293" />
        <PricingSection data-id="element-294" />
        <ServiceAreaSection data-id="element-295" />
        <CTABannerSection data-id="element-296" />
      </main>
      <Footer data-id="element-297" />
    </div>;
}